var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnGasPrice = function SvgIcnGasPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.236 11.984c.117.063.24-.072.169-.184-.39-.606-.759-1.627-.171-2.94.98-2.191 1.576-3.326 1.576-3.326s.318 1.324 1.177 2.502c.828 1.133 1.28 2.558.55 3.745-.068.112.053.243.17.184.903-.463 1.917-1.39 2.032-3.236.042-.564-.021-1.354-.338-2.35-.406-1.263-.906-1.852-1.196-2.105a.13.13 0 0 0-.214.106c.085 1.363-.428 1.708-.72.93-.116-.312-.184-.85-.184-1.506 0-1.092-.317-2.215-1.015-3.128a3.543 3.543 0 0 0-.638-.649.13.13 0 0 0-.208.112C5.28.88 5.231 3 3.371 5.533c-1.687 2.35-1.033 4.155-.801 4.644.443.936 1.062 1.486 1.666 1.807Z",
    fill: "#292525"
  })));
};
export default SvgIcnGasPrice;